const allVouch = { data: [], loading: true };

export const GetAllRevertBackVouchers = (state = allVouch, action) => {
  switch (action.type) {
    case "get_revertbackVouch":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
